<div class="video-card-content">
  <div class="video-card-top">
    <ng-content select="[top-content]"></ng-content>
  </div>
  <div class="video-card-header">
    <div class="video-card-header-item">
      <div class="icon">
        <img
          src="assets/static/icons/time.svg"
          alt="Icono de duración del video"
        />
      </div>
      <div class="text">
        @if (isLoading()) {
        <span class="skeleton"> 00:00 </span>
        } @else {
        {{ getFormatedVideoDuration() }}
        }
      </div>
    </div>
    <div class="video-card-header-item">
      <div class="icon">
        <img
          src="assets/static/icons/bookmark.svg"
          alt="Icono de número de escenas del video"
        />
      </div>
      <div class="text">
        @if (isLoading()) {
        <span class="skeleton"> 10000 </span>
        } @else {
        {{ 10 }}
        }
      </div>
    </div>
  </div>
  <div class="video-card-middle">
    <ng-content select="[middle-content]"></ng-content>
  </div>
  <div class="video-card-tags">
    <div class="video-card-tabs-container">
      @if (isLoading()) {
      <div class="tag skeleton">
        <span> some tag </span>
      </div>
      <div class="tag skeleton">
        <span class="skeleton"> some tag </span>
      </div>
      <div class="tag skeleton">
        <span class="skeleton"> some tag </span>
      </div>
      <div class="tag skeleton">
        <span class="skeleton"> some tag </span>
      </div>
      <div class="tag skeleton">
        <span class="skeleton"> some tag </span>
      </div>
      } @else {
      <div class="tag" [title]="video?.gender">
        <div class="text">#{{ video?.gender }}</div>
      </div>
      <div class="tag" [title]="video?.category">
        <div class="text">#{{ video?.category }}</div>
      </div>
      <div class="tag" [title]="video?.competition">
        <div class="text">#{{ video?.competition }}</div>
      </div>
      <div class="tag" [title]="video?.championship">
        <div class="text">#{{ video?.championship }}</div>
      </div>
      }
    </div>
  </div>
  <div class="video-card-bottom">
    <ng-content select="[bottom-content]"></ng-content>
  </div>
</div>
